<app-spinner *ngIf="loading"></app-spinner>

<div class="top" *ngIf="!loading">
  <div class="filters">
    <button
      md-raised-button
      [color]="contribued === null ? 'primary' : ''"
      (click)="setContribued(null)"
    >
      All
    </button>
    <button
      md-raised-button
      [color]="contribued === true ? 'primary' : ''"
      (click)="setContribued(true)"
    >
      Contribued
    </button>
    <button
      md-raised-button
      [color]="contribued === false ? 'primary' : ''"
      (click)="setContribued(false)"
    >
      Not contribued
    </button>
  </div>
  <md-slide-toggle
    [checked]="currentEvents"
    (change)="changeCurrentEvents($event)"
    (change)="refresh()"
  >
    Events for today</md-slide-toggle
  >
  <form (keyup)="refresh()">
    <md-form-field>
      <input
        name="term"
        type="text"
        mdInput
        [(ngModel)]="term"
        placeholder="Search"
      />
    </md-form-field>
    <button md-raised-button type="submit" color="primary" (click)="load()">
      <md-icon>search</md-icon>
      Search
    </button>
    <button md-raised-button type="button" (click)="searchClear()">
      <md-icon>clear</md-icon>
      Clear
    </button>
  </form>
</div>

<ngx-datatable
  #table
  *ngIf="!loading && sportingEventsFiltered !== null"
  style="height: 90vh; width: 100%"
  class="material"
  [rows]="sportingEventsFiltered"
  [columnMode]="'force'"
  [headerHeight]="50"
  [scrollbarV]="true"
  [rowHeight]="50"
  [reorderable]="true"
>
  <ngx-datatable-column name="Id" [width]="5">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span>{{ row.id }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Start date" [width]="5">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span>{{ row.startDate }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="End date" [width]="5">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span>{{ row.endDate }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Name" [width]="450">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span>{{ row.name }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Contribued" [width]="5">
    <ng-template ngx-datatable-cell-template let-row="row">
      <md-icon *ngIf="row.isContribued">done</md-icon>
      <md-icon *ngIf="!row.isContribued">close</md-icon>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Pictures" [width]="5">
    <ng-template ngx-datatable-cell-template let-row="row">
      <md-chip-list>
        <md-chip (click)="editPicture(row)">{{
          row.isContribued ? "Update" : "Upload"
        }}</md-chip>
      </md-chip-list>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Multilingual" [width]="5">
    <ng-template ngx-datatable-cell-template let-row="row">
      <md-chip-list>
        <md-chip (click)="openMultilingual(row)">Multilingual</md-chip>
      </md-chip-list>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="MAX Additional pictures" [width]="50">
    <ng-template ngx-datatable-cell-template let-row="row">
      <md-chip-list>
        <md-chip (click)="seeAdditionalPictures(row)">
          {{ row.isContribued ? "Update" : "Upload" }}
        </md-chip>
      </md-chip-list>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>



// WEBPACK FOOTER //
// ./src/app/pages/event-article/event-article.component.html